import styled from 'styled-components'
import { COLORS } from 'utils'

interface IContainer {
  margin?: string
}

interface ITitleContainer {
  type?: string
}

export const Container = styled.div<IContainer>`
  width: 100%;
  height: auto;
  background: ${COLORS.white};
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.25);
  margin: ${({ margin }) => margin || 'auto'};
`

export const TitleContainer = styled.div<ITitleContainer>`
  background: ${({ type }) => {
    switch (type) {
      case 'normal':
        return COLORS.tableColor
      case 'danger':
        return COLORS.error
      case 'success':
        return COLORS.success
      default:
        return COLORS.tableColor
    }
  }};
  padding: 4px 6px;
  text-align: center;
  text-transform: uppercase;
`
export const Content = styled.div`
  width: auto;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 5% 2%;
`
